import { Globe, Layers, Zap, Code2, Lock, Headset } from 'lucide-react';

const reasons = [
  {
    icon: <Globe className="h-5 w-5" />,
    title: 'Built for India, ready for the world',
    desc:
      'GST, e-Invoice, e-Way Bill, HSN/SAC, TDS, ITC reconciliation, multi-currency and multi-branch — out of the box.',
  },
  {
    icon: <Layers className="h-5 w-5" />,
    title: 'Modular by design',
    desc:
      'Turn on Sales today, add POS, Accounting, Restaurant or Manufacturing later. No re-implementation, no double entry.',
  },
  {
    icon: <Zap className="h-5 w-5" />,
    title: 'Fast to deploy',
    desc:
      'Most teams are live in days, not quarters. Templates, CSV import and a live demo tenant get you started in minutes.',
  },
  {
    icon: <Code2 className="h-5 w-5" />,
    title: 'Developer-friendly',
    desc:
      'A clean OpenAPI surface (280+ resources), webhooks, role-based access and a per-row audit trail. Integrate without surprises.',
  },
  {
    icon: <Lock className="h-5 w-5" />,
    title: 'Compliance-grade security',
    desc:
      'Multi-tenant isolation, MFA, refresh-token rotation, fine-grained permissions and full audit log on every change.',
  },
  {
    icon: <Headset className="h-5 w-5" />,
    title: 'Support that picks up',
    desc:
      'Email, chat and phone support staffed by people who know the product — plus a free migration assist on Growth and above.',
  },
];

export default function WhyChooseUs() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
      <div className="max-w-2xl">
        <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl">Why teams choose KSS BillBook</h2>
        <p className="mt-2 text-sm text-[var(--color-text-secondary)] sm:text-base">
          Built on five years of running billing and accounting for Indian SMBs — every feature
          here came from a real customer ask, not a checklist.
        </p>
      </div>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {reasons.map((r) => (
          <div
            key={r.title}
            className="rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-card)] p-5"
          >
            <div className="flex items-center gap-3">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-[var(--color-primary)]/10 text-[var(--color-primary)]">
                {r.icon}
              </span>
              <h3 className="text-base font-semibold">{r.title}</h3>
            </div>
            <p className="mt-3 text-sm text-[var(--color-text-secondary)]">{r.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
